/**
 * @file   src\mobile\components\MarkAsSoldModal.js
 * @brief  This file is responsible for mark as sold action on inventory
 * @date   April, 2024
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import React from "react";
import { Modal } from "react-bootstrap";

const MarkAsSoldModal = (props) => {
  const { handleInventoryMarkAsSold, show, onHide, inventoryId } = props;
  return (
    <Modal
      show={show}
      {...props}
      onHide={onHide}
      centered
      className="modalPopupstyle delete-popup"
    >
      <Modal.Body className="text-center">
        <h3>Ready to mark this property as sold?</h3>
        <p>
          Marking this property as sold will remove any pending introductions
          sent by you.
        </p>
        <div className="btn-wrap">
          <button
            type="button"
            className="btn btn-primary w-100"
            onClick={() => handleInventoryMarkAsSold(inventoryId)}
          >
            Mark as sold
          </button>
          <button
            type="button"
            className="btn btn-secondary w-100"
            onClick={() => onHide(false)}
          >
            Cancel
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default MarkAsSoldModal;
